import { render, staticRenderFns } from "./product-body-shapes.vue?vue&type=template&id=5667c802&scoped=true&"
import script from "./product-body-shapes.vue?vue&type=script&lang=js&"
export * from "./product-body-shapes.vue?vue&type=script&lang=js&"
import style0 from "./product-body-shapes.vue?vue&type=style&index=0&id=5667c802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667c802",
  null
  
)

export default component.exports